<div class="subBlockContainer" id="apiCredentialsV2" *ngIf="hasAdminAccess">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
        <p class="page-title-description">Get connected with Dicker Data’s API V2 suite to enhance your experience.  Below you can generate API access client credentials for both the production system as well as our sandbox environment.</p>
        <p>Please follow the below link to our documentation on all our V2 API's</p>
        <a class="button button-red button-medium" href="https://portal.dickerdata.com.au/">Documentation</a>
        <section style="width: 400px;">
          <!-- <ng-select class="customDropdwon" [items]="userList" bindValue="out_email" bindLabel="out_login_id"
            placeholder="Select Integration Contact" [clearable]="true" [(ngModel)]="selectedUserEmail"></ng-select>
            <mat-form-field>
              <input matInput [(ngModel)]="selectedUserEmail" placeholder="Integration Contact Email">              
            </mat-form-field> -->
            <mat-form-field>
              <input matInput [(ngModel)]="currentUser" placeholder="Integration Contact" readonly>              
            </mat-form-field>
            <mat-form-field>
              <input matInput [(ngModel)]="currentUserEmail" placeholder="Integration Contact Email" readonly>              
            </mat-form-field>
            <mat-form-field>
              <input matInput [(ngModel)]="credentialsDisplayName" placeholder="Credentials Display Name">
            </mat-form-field>
        </section>
        <section>
          <div>PLESE BE ADVISED THE CLIENT SECRET WILL ONLY BE ACCESSIBLE AT THE TIME OF CREATION, AFTER THE PAGE HAS BEEN RELOADED OR MOVED AWAY FROM, THE CLIENT SECRET WILL NOT BE AVAILABLE</div>
        </section>
        <mat-accordion multi>
          <!-- LIVE CREDENTIALS -->
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title *ngIf="!isTestMode" class="highlight-text"> PRODUCTION CREDENTIALS </mat-panel-title>
              <mat-panel-title *ngIf="isTestMode" class="highlight-text"> SANDBOX CREDENTIALS </mat-panel-title>
              <mat-panel-description class="panel-subtitle">
               <mat-spinner
                  *ngIf="prodCredentialsLoading"
                  mode="indeterminate"
                  class="circle cSPCustomerEntitlements-loading"
                  diameter="20" 
                ></mat-spinner>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <section>
               <button *ngIf="!isTestMode" class="button button-red button-medium" (click)="generateCredentials('prod')">Generate Live Credentials</button>
               <button *ngIf="isTestMode" class="button button-red button-medium" (click)="generateCredentials('prod')">Generate Sandbox Credentials</button>
            </section>
            <section *ngIf="prodCredentials.length > 0">
              <table>
                <thead>
                  <tr>
                    <th class="col-3">DISPLAY NAME</th>
                    <th class="col-4">CLIENT ID</th>
                    <th class="col-2">CLIENT SECRET</th>
                    <th class="col-2">CREATED BY</th>
                    <th class="col-1">EXPIRY</th>
                    <th class="col-1"></th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let i = index; let item of prodCredentials">
                    <tr>
                      <td class="col-2">{{item?.displayName}}</td>
                      <td class="col-3" matTooltip="CLick to Copy" 
                      (click)="copyText(item?.clientId)">{{item?.clientId}}</td>
                      <td class="col-3" (click)="copyText(item?.clientSecret)">
                        <span *ngIf="item?.clientSecret" class="compact-client-secret"
                        matTooltip="CLick to Copy">{{item?.clientSecret}}</span>
                        <span *ngIf="!item?.clientSecret" class="compact-client-secret">************************</span>
                      </td>
                      <td class="col-2">{{item?.createdBy}}</td>
                      <td class="col-1">{{item?.expiryDate | date: 'dd/MM/yyyy'}}</td>
                      <td class="col-1">
                        <span id="prodCredentialsDeleteButton" class="basic-icon delete-icon delete-button" (click)="deleteCredentials('prod', item?.id, i)"></span>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </section>
          </mat-expansion-panel>
          <!-- SANDBOX CREDENTIALS -->
          <mat-expansion-panel *ngIf="!isTestMode" expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="highlight-text"> SANDBOX CREDENTIALS </mat-panel-title>
              <mat-panel-description class="panel-subtitle">
                <mat-spinner
                  *ngIf="sandboxCredentialsLoading"
                  mode="indeterminate"
                  class="circle cSPCustomerEntitlements-loading"
                  diameter="20" 
                ></mat-spinner>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <section>
              <button class="button button-red button-medium" (click)="generateCredentials('sandbox')">Generate Sandbox Credentials</button>
            </section>
            <section *ngIf="sandboxCredentials.length > 0">
            <table>
              <thead>
                <tr>
                  <th class="col-3">DISPLAY NAME</th>
                  <th class="col-4">CLIENT ID</th>
                  <th class="col-2">CLIENT SECRET</th>
                  <th class="col-2">CREATED BY</th>
                  <th class="col-1">EXPIRY</th>
                  <th class="col-1"></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let i = index; let item of sandboxCredentials">
                  <tr>
                    <td class="col-3">{{item?.displayName}}</td>
                    <td class="col-4" matTooltip="CLick to Copy"
                    (click)="copyText(item?.clientId)">{{item?.clientId}}</td>
                    <td class="col-2" (click)="copyText(item?.clientSecret)">
                      <span *ngIf="item?.clientSecret" class="compact-client-secret"
                      matTooltip="CLick to Copy">{{item?.clientSecret}}</span>
                      <span *ngIf="!item?.clientSecret" class="compact-client-secret">************************</span>
                    </td>
                    <td class="col-2">{{item?.createdBy}}</td>
                    <td class="col-1">{{item?.expiryDate | date: 'dd/MM/yyyy'}}</td>
                    <td class="col-1">
                      <span id="sbCredentialsDeleteButton" class="basic-icon delete-icon delete-button" (click)="deleteCredentials('sandbox', item?.id, i)"></span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
            </section>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
    <loading-screen *ngIf="!loadContent" backDropWidth='350' [showBlurTable]="false" (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
  <modal-popup [modalTitle]="modalDetails.title" [modalContent]="modalDetails.content"></modal-popup>
</div>